import { ColumnDefinitionModel } from "@/modules/core/common/services/GridService";
import { FilterDefinitionModel } from "@/modules/core/common/services/FiltersDefinitionService";

export default {
    namespaced: true,
    state: {
        instances: {},
        columns: null,
        filters: null,
        showColumns: true,
        showFilters: true,
        filtersInitialized: false
    } as State,
    mutations: {
        SET_COLUMNS: (state: State, payload: MutationPayload<ColumnDefinitionModel>): void =>
        {
            const { key, value } = normalizePayload(payload);
            state.columns = value;
            ensureInstance(state, key).columns = value;
        },
        SET_FILTERS: (state: State, payload: MutationPayload<FilterDefinitionModel>): void =>
        {
            const { key, value } = normalizePayload(payload);
            state.filters = value;
            ensureInstance(state, key).filters = value;
        },
        SET_FILTERS_VISIBILITY: (state: State, payload: MutationPayload<boolean>): void =>
        {
            const { key, value } = normalizePayload(payload);
            state.showFilters = value;
            ensureInstance(state, key).showFilters = value;
        },
        SET_COLUMNS_VISIBILITY: (state: State, payload: MutationPayload<boolean>): void =>
        {
            const { key, value } = normalizePayload(payload);
            state.showColumns = value;
            ensureInstance(state, key).showColumns = value;
        },
        SET_INITIALIZATION: (state: State, payload: MutationPayload<boolean>): void =>
        {
            const { key, value } = normalizePayload(payload);
            state.filtersInitialized = value;
            ensureInstance(state, key).filtersInitialized = value;
        },
        CLEAR_ALL: (state: State, key?: string): void =>
        {
            const instanceKey = key || DEFAULT_INSTANCE_KEY;
            state.columns = null;
            state.filters = null;
            state.showColumns = true;
            state.showFilters = true;

            state.instances[instanceKey] = defaultInstanceState();
        }
    }
};

const DEFAULT_INSTANCE_KEY = '__global__';

const defaultInstanceState = (): GridStateInstance => ({
    columns: null,
    filters: null,
    showColumns: true,
    showFilters: true,
    filtersInitialized: false,
});

const ensureInstance = (state: State, key: string): GridStateInstance =>
{
    const nextKey = key || DEFAULT_INSTANCE_KEY;

    if (!state.instances[nextKey])
    {
        state.instances[nextKey] = defaultInstanceState();
    }

    return state.instances[nextKey];
};

const normalizePayload = <T>(payload: MutationPayload<T>): { key: string; value: T } =>
{
    if (payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'value'))
    {
        const typedPayload = payload as KeyedPayload<T>;

        return {
            key: typedPayload.key || DEFAULT_INSTANCE_KEY,
            value: typedPayload.value,
        };
    }

    return {
        key: DEFAULT_INSTANCE_KEY,
        value: payload as T,
    };
};

interface State {
    instances: Record<string, GridStateInstance>,
    columns: ColumnDefinitionModel,
    filters: FilterDefinitionModel,
    showColumns: boolean,
    showFilters: boolean,
    filtersInitialized: boolean
}

interface GridStateInstance {
    columns: ColumnDefinitionModel,
    filters: FilterDefinitionModel,
    showColumns: boolean,
    showFilters: boolean,
    filtersInitialized: boolean
}

type KeyedPayload<T> = {
    key?: string;
    value: T;
};

type MutationPayload<T> = T | KeyedPayload<T>;
